export default __webpack_public_path__ + "static/media/marker-icon.a7797b0a.svg";